import { createSharedComposable } from '@vueuse/core';
import { useModal } from './useModal';

export const useSideMenuModal = createSharedComposable(useModal);
